import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "preview"
  }, [_vm._l(_vm.previews, function (item, i) {
    return [_c("div", {
      class: ["platform", item.class, _vm.platform === item.name ? "active" : ""]
    }, [_c("iframe", {
      ref: "frame",
      refInFor: true,
      attrs: {
        src: item.link,
        frameborder: "0"
      }
    })])];
  }), _c("div", {
    staticClass: "op-wrapper"
  }, _vm._l(_vm.previews, function (item, i) {
    return _c("i", {
      class: [item.icon, _vm.platform === item.name ? "active" : ""],
      on: {
        click: function click($event) {
          return _vm.handlePlatformClick(item);
        }
      }
    });
  }), 0)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };